import Loadable from '../../components/loadable';

const EmailVerificationsReport = Loadable({
  loader: () => import('../../pages/reports/email_verifications_report/email_verifications_report'),
});

angular.module('gym').value('EmailVerificationsReport', EmailVerificationsReport);

const EmailVerificationsReportFiltersModal = Loadable({
  loader: () =>
    import(
      '../../pages/reports/email_verifications_report/email_verifications_report_filters_modal'
    ),
  type: 'modal',
});

angular
  .module('gym')
  .value('EmailVerificationsReportFiltersModal', EmailVerificationsReportFiltersModal);
